import React from 'react';

import dynamic from 'next/dynamic';

import Counter from '@components/Counter/Counter';

const DateInput = dynamic(() => import('@components/DateInput/DateInput'));

import { KidInterface } from './ListingSearchGuestInterface';
import {
  GuestChildAgePicker,
  StyledListingGuestRoom,
  GuestRoomBlock,
  GuestRoomInfo,
  GuestRoomSubtitle,
  GuestRoomText,
  GuestRoomTitle,
} from './SearchGuestStyle';

interface SearchGuestItemProps {
  title: string;
  subTitle: string;
  count: number;
  handleDecrement: () => void;
  handleIncrement: () => void;
  isChildCounter?: boolean;
  min?: number;
  childrenList?: Array<KidInterface>;
  changeChildAge?: (kidId: string, age: string) => void | null;
  maxAge?: number;
}
const ListingSearchGuestItem = (props: SearchGuestItemProps) => {
  // ================================
  // Getting the props for the component
  // ================================
  const {
    title,
    subTitle,
    handleIncrement,
    handleDecrement,
    count,
    isChildCounter,
    childrenList,
    changeChildAge,
    min,
    maxAge = 15,
  } = props;

  // ================================
  // Render the child date picker
  // ================================
  const renderKidsDatePicker = (): React.JSX.Element[] | undefined => {
    if (!childrenList) return;

    return childrenList?.map((item, index) => (
      <div ref={item.ref} key={item.id}>
        <DateInput
          date={item.age}
          label={`${Number(index + 1).toString()}. Çocuk Doğum Tarihi`}
          error={item.error}
          handleDatePick={(e, b) => {
            changeChildAge?.(item.id, b);
          }}
          maxAge={maxAge}
        />
      </div>
    ));
  };

  // ================================
  // Render the main component jsx
  // ================================
  return (
    <StyledListingGuestRoom>
      <GuestRoomBlock>
        <GuestRoomInfo>
          <GuestRoomText>
            <GuestRoomTitle>{title}</GuestRoomTitle>
            <br />
            <GuestRoomSubtitle>{subTitle}</GuestRoomSubtitle>
          </GuestRoomText>
        </GuestRoomInfo>

        <Counter
          handleIncrement={handleIncrement}
          handleDecrement={handleDecrement}
          count={count}
          min={min}
        />
      </GuestRoomBlock>

      <br />
      {isChildCounter && isChildCounter === true && count > 0 ? (
        <GuestChildAgePicker data-testid='child-counter-picker'>
          {renderKidsDatePicker()}
        </GuestChildAgePicker>
      ) : null}
    </StyledListingGuestRoom>
  );
};

export default ListingSearchGuestItem;
